








import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';
import JerseyQuestion from '@/components/elements/JerseyQuestion.vue';
import JerseyDropdown from '@/components/elements/JerseyDropdown.vue';
import QuestionLayout from '@/views/QuestionLayout.vue';

export default Vue.extend({
  name: 'WhichClub',
  components: {
    JerseyButtonRed,
    JerseyQuestion,
    JerseyDropdown,
    QuestionLayout,
  },
  computed: {
    question() {
      return (this as any).$store.state.isMobile
        ? (this as any).$store.state.club.questionMobile
        : (this as any).$store.state.club.question;
    },
    options() {
      return (this as any).$store.state.club.options;
    },
  },
});
